import BaseService from 'services/base'

export default class OverbillService extends BaseService {
  constructor(api) {
    super(api)
    this.api = api
  }

  getOverbillApproval(key) {
    return this.get(`overbill/${key}`)
  }

  approveOverbill(piId) {
    return this.put(`overbill/${piId}/approve`)
  }

  rejectOverbill(piId, payload) {
    return this.put(`overbill/${piId}/reject`, payload)
  }
}
